import { z } from 'zod'
import { parseKwacha } from '@/lib/money'

/** Parse a Kwacha text box into whole ngwee (null when invalid or not above zero). */
export function amountToNgwee(text: string): number | null {
  const n = parseKwacha(text)
  return n !== null && n > 0 ? n : null
}

export const lineFormSchema = z.object({
  categoryId: z.string().min(1, 'Pick a category'),
  description: z.string().trim().min(2, 'Say what the money is for').max(120, 'Use a shorter description'),
  amount: z.string().refine((v) => amountToNgwee(v) !== null, 'Enter an amount like 500 or 500.00'),
  note: z.string().trim().max(300, 'Use a shorter note'),
})
export type LineFormValues = z.infer<typeof lineFormSchema>

export const reasonSchema = z.object({
  reason: z.string().trim().min(3, 'Give a reason (at least a few words)').max(300, 'Use a shorter reason'),
})

/** 'YYYY-Q3' -> 'July to September 2026 (Q3)'. */
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
export function quarterLabel(id: string): string {
  const m = /^(\d{4})-Q([1-4])$/.exec(id)
  if (!m) return id
  const first = (Number(m[2]) - 1) * 3
  return `${MONTHS[first]} to ${MONTHS[first + 2]} ${m[1]} (Q${m[2]})`
}
